










import Vue from 'vue'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import { ColumnChartData } from '@/model/dashboard/ColumnChartData'

am4core.useTheme(am4themes_animated)

interface ComponentData {
  chart: any
}

export default Vue.extend({
  name: 'ColumnInverseChart',

  props: {
    columnInverseChartLabel: String,
    columnInverseChartData: {
      type: Array as () => Array<ColumnChartData>
    },
    columnInverseChartDate: String
  },

  data (): ComponentData {
    return {
      chart: undefined
    }
  },

  methods: {
    createChart (): any {

      //@ts-ignore
      let chart = am4core.create(this.$refs.columnChart, am4charts.XYChart)

      // Add data
      chart.data = this.columnInverseChartData.reverse()

      // Add and configure Series
      let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = 'employee'
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.renderer.labels.template.rotation = 0
      categoryAxis.renderer.labels.template.verticalCenter = 'middle'
      categoryAxis.renderer.labels.template.horizontalCenter = 'right'
      categoryAxis.renderer.minGridDistance = 20

      let valueAxis = chart.xAxes.push(new am4charts.ValueAxis())
      valueAxis.min = 0
      valueAxis.renderer.minGridDistance = 10
      valueAxis.max = 200

      // Create series
      function createSeries (field: string, name: string, color: string): any {

        // Set up series
        let series = chart.series.push(new am4charts.ColumnSeries())
        series.name = name
        series.dataFields.valueX = field
        series.dataFields.categoryY = 'employee'
        series.sequencedInterpolation = true

        // Make it stacked
        series.stacked = true

        // Configure columns
        series.columns.template.width = am4core.percent(60)
        series.columns.template.tooltipText = '[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}'
        series.columns.template.adapter.add('tooltipText', function (text: any, target: any, key: any): string {
          if (field === 'duration') {
            return '{durationTime}'
          } else if (field === 'capacity') {
            return '{capacityTime}'
          } else if (field === 'overtime') {
            return '{overtimeTime}'
          } else if (field === 'absence') {
            return '{absenceTime}'
          } else {
            return ''
          }

        })

        // Add label
        let labelBullet = series.bullets.push(new am4charts.LabelBullet())
        labelBullet.locationY = 0.5
        labelBullet.label.hideOversized = true
        series.columns.template.fill = am4core.color(color)
        return series
      }

      createSeries('duration', this.$t('dashboard.planned').toString(), '#BBDEFB')
      createSeries('capacity', this.$t('dashboard.freeCapacity').toString(), '#43A047')
      createSeries('overtime', this.$t('dashboard.overtime').toString(), '#D50000')
      createSeries('absence', this.$t('dashboard.absences').toString(), '#FFFF00')

      // Legend
      chart.legend = new am4charts.Legend()

      let cellSize = 20
      chart.events.on('datavalidated', function (ev: any) {

        // Get objects of interest
        let chart = ev.target
        let categoryAxis = chart.yAxes.getIndex(0)

        // Calculate how we need to adjust chart height
        let adjustHeight = chart.data.length * cellSize - categoryAxis.pixelHeight

        // get current chart height
        let targetHeight = chart.pixelHeight + adjustHeight

        // Set it on chart's container
        chart.svgContainer.htmlElement.style.height = targetHeight + 'px'

      })

      this.chart = chart
    }
  },

  mounted () {
    this.createChart()
  },

  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }

})
